import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	allowedNo: {
		id: 'ui.contentOverview.allowed.no',
	},
	allowedYes: {
		id: 'ui.contentOverview.allowed.yes',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: boolean;
	}>;
};



const RobotsTxtChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: false,
			label: intl.formatMessage(messages.allowedYes),
			color: '#42CC67',
		},
		{
			value: true,
			label: intl.formatMessage(messages.allowedNo),
			color: '#FF743B',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			name="is_disallowed_in_robots_txt"
			percentageFactor={100}
		/>
	);
};



export default React.memo(RobotsTxtChart);
